import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "@/components/ui/button";

interface QRCodeSectionProps {
  link: string;
}

/**
 * QRCodeSection Component
 *
 * Collapsible QR kod gösterim component'i
 */
export const QRCodeSection: React.FC<QRCodeSectionProps> = ({ link }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-2xl border border-border-secondary dark:border-gray-700 bg-white/60 dark:bg-gray-900/20">
      {/* Toggle Button */}
      <Button
        variant="ghost"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-4 py-3 rounded-2xl hover:bg-bg-secondary dark:hover:bg-gray-800 transition-colors"
      >
        <span className="text-sm font-medium text-text-primary dark:text-gray-100">
          {isOpen ? t("chat.share.hideQRCode") : t("chat.share.showQRCode")}
        </span>
        {isOpen ? (
          <ChevronUp className="w-4 h-4 text-text-secondary dark:text-gray-400" />
        ) : (
          <ChevronDown className="w-4 h-4 text-text-secondary dark:text-gray-400" />
        )}
      </Button>

      {/* QR Code Display */}
      {isOpen && (
        <div className="px-4 pb-4">
          <div className="mt-3 flex flex-col items-center gap-3 rounded-xl  p-4">
            <div className="p-4 bg-white rounded-xl shadow-sm ring-1 ring-black/5">
              <QRCodeSVG
                value={link}
                size={200}
                level="H"
                includeMargin={true}
              />
            </div>
            <p className="text-xs text-text-secondary dark:text-gray-400 text-center max-w-xs">
              {t("chat.share.qrCodeDescription")}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
